import React, {Component} from 'react';

export default class TitleContent extends Component {
  /** @function
   * Renders the Title Content component.
   */
  render() {
    return (
      <h1>{this.props.text}</h1>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/title-content.js